import { produce } from "immer";
import * as Actions from "pages/Settings/WhitelistBlacklist/store/bwlistsActions";
import { normalizeTrustAddress } from "utils/helpers/senderTrust";

const initialState = {
  isLoading: false,
  errorMessage: null,
  incoming: {
    blacklist: [],
    whitelist: []
  },
  outgoing: {
    blacklist: [],
    whitelist: []
  },
  trustedIncomingAddresses: [],
  removedTrustedIncomingAddresses: []
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.SET_LOADING: {
      draft.isLoading = action.payload;
      break;
    }

    case Actions.SET_ERROR_MESSAGE: {
      draft.errorMessage = action.payload;
      break;
    }

    case Actions.FETCH_BWLISTS_SUCCESS: {
      draft.isLoading = false;
      draft.incoming = action.payload.incoming;
      draft.outgoing = action.payload.outgoing;
      const removedTrustedIncomingAddresses =
        draft.removedTrustedIncomingAddresses || [];
      draft.removedTrustedIncomingAddresses = Array.from(
        removedTrustedIncomingAddresses
      );
      draft.trustedIncomingAddresses = (
        action.payload.incoming?.whitelist || []
      )
        .map(item => normalizeTrustAddress(item?.address))
        .filter(
          address =>
            address && !removedTrustedIncomingAddresses.includes(address)
        );

      break;
    }

    case Actions.ADD_TRUSTED_INCOMING_ADDRESS: {
      const address = normalizeTrustAddress(action.payload);
      const trustedIncomingAddresses =
        draft.trustedIncomingAddresses ||
        (draft.trustedIncomingAddresses = []);

      if (address && !trustedIncomingAddresses.includes(address)) {
        trustedIncomingAddresses.push(address);
      }
      draft.removedTrustedIncomingAddresses = (
        draft.removedTrustedIncomingAddresses || []
      ).filter(item => item !== address);

      break;
    }

    case Actions.REMOVE_TRUSTED_INCOMING_ADDRESS: {
      const address = normalizeTrustAddress(action.payload);
      draft.trustedIncomingAddresses = (
        draft.trustedIncomingAddresses || []
      ).filter(item => item !== address);
      const removedTrustedIncomingAddresses =
        draft.removedTrustedIncomingAddresses ||
        (draft.removedTrustedIncomingAddresses = []);

      if (address && !removedTrustedIncomingAddresses.includes(address)) {
        removedTrustedIncomingAddresses.push(address);
      }

      break;
    }

    case Actions.RESET_BWLISTS: {
      return {
        ...initialState,
        incoming: {
          ...initialState.incoming
        },
        outgoing: {
          ...initialState.outgoing
        },
        trustedIncomingAddresses: Array.from(
          draft.trustedIncomingAddresses || []
        ),
        removedTrustedIncomingAddresses: Array.from(
          draft.removedTrustedIncomingAddresses || []
        )
      };
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
